import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import ai from "./client-hints-parser.js";
import oi from "./user-agent-parser.js";
import { Browsers as gi, OperatingSystems as so } from "./device-constants.js";
var di = /*#__PURE__*/function () {
  function di() {
    var _this = this;
    _classCallCheck(this, di);
    var t = navigator.userAgentData ? ai : oi;
    this.Sg = new t(), this.userAgent = navigator.userAgent, this.browser = this.Sg.ef(), this.version = this.Sg.ff(), this.OS = null, this.Ja().then(function (t) {
      return _this.OS = t;
    });
    var i = navigator;
    this.language = (i.userLanguage || i.language || i.browserLanguage || i.systemLanguage || "").toLowerCase(), this.Pa = di.vg(this.userAgent);
  }
  _createClass(di, [{
    key: "bE",
    value: function bE() {
      return this.browser === gi.xg;
    }
  }, {
    key: "Ka",
    value: function Ka() {
      return this.OS || null;
    }
  }, {
    key: "Ja",
    value: function Ja() {
      var _this2 = this;
      return this.OS ? Promise.resolve(this.OS) : this.Sg.Ja(di.kg).then(function (t) {
        return _this2.OS = t, t;
      });
    }
  }], [{
    key: "vg",
    value: function vg(t) {
      t = t.toLowerCase();
      var i = ["googlebot", "bingbot", "slurp", "duckduckbot", "baiduspider", "yandex", "facebookexternalhit", "sogou", "ia_archiver", "https://github.com/prerender/prerender", "aolbuild", "bingpreview", "msnbot", "adsbot", "mediapartners-google", "teoma", "taiko", "petalbot", "facebookexternalhit", "facebookcatalog", "meta-webindexer", "meta-externalads", "meta-externalagent", "meta-externalfetcher"];
      for (var n = 0; n < i.length; n++) if (-1 !== t.indexOf(i[n])) return !0;
      return !1;
    }
  }]);
  return di;
}();
di.kg = [{
  string: navigator.platform,
  cf: "Win",
  identity: so.Bg
}, {
  string: navigator.platform,
  cf: "Mac",
  identity: so.Og
}, {
  string: navigator.platform,
  cf: "BlackBerry",
  identity: "BlackBerry"
}, {
  string: navigator.platform,
  cf: "FreeBSD",
  identity: "FreeBSD"
}, {
  string: navigator.platform,
  cf: "OpenBSD",
  identity: "OpenBSD"
}, {
  string: navigator.platform,
  cf: "Nintendo",
  identity: "Nintendo"
}, {
  string: navigator.platform,
  cf: "SunOS",
  identity: "SunOS"
}, {
  string: navigator.platform,
  cf: "PlayStation",
  identity: "PlayStation"
}, {
  string: navigator.platform,
  cf: "X11",
  identity: "X11"
}, {
  string: navigator.userAgent,
  cf: ["iPhone", "iPad", "iPod"],
  identity: so.co
}, {
  string: navigator.platform,
  cf: "Pike v",
  identity: so.co
}, {
  string: navigator.userAgent,
  cf: ["Web0S"],
  identity: "WebOS"
}, {
  string: navigator.userAgent,
  cf: "Tizen",
  identity: "Tizen"
}, {
  string: navigator.userAgent,
  cf: "Coolita",
  identity: "Other Smart TV"
}, {
  string: navigator.userAgent,
  cf: "WhaleTV",
  identity: "Other Smart TV"
}, {
  string: navigator.platform,
  cf: ["Linux armv7l", "Android"],
  identity: so.Pg
}, {
  string: navigator.userAgent,
  cf: ["Android"],
  identity: so.Pg
}, {
  string: navigator.platform,
  cf: "Linux",
  identity: "Linux"
}];
var ro = new di();
export { ro as default, di as BrowserDetector };